<template lang="html">
  <b-form class="box-search-component" @submit="onSubmitTrip">
    <div class="row box-top">
      <div class="col-6 col-button">
        <a class="btn btn-opt" v-bind:class="{ active: searchForm.type == 1 }" @click="selectType(1)">SENCILLO</a>
      </div>

      <div class="col-6 col-button">
        <a class="btn btn-opt" v-bind:class="{ active: searchForm.type == 2 }" @click="selectType(2)">IDA Y VUELTA</a>
      </div>
    </div>

    <div class="box-form">
      <b-form-group class="custom-f-group-s1">
        <b-form-datepicker dropright required v-model="searchForm.ida" :min="minDate" :date-format-options="dateFormOpts" v-bind="datepickerOpts" placeholder="Fecha ida"></b-form-datepicker>
      </b-form-group>

      <b-form-group class="custom-f-group-s1" v-if="searchForm.type == 2">
        <b-form-datepicker dropright required v-model="searchForm.regreso" :min="minDate" :date-format-options="dateFormOpts" v-bind="datepickerOpts" placeholder="Fecha regreso"></b-form-datepicker>
      </b-form-group>

      <b-form-group class="custom-f-group-s1">
        <b-form-select required class="form-select" v-bind:class="{ 'text-muted' : searchForm.origen == null }" v-model="searchForm.origen">
          <b-form-select-option :value="null">Origen</b-form-select-option>
          <b-form-select-option value="1">Guadalajara</b-form-select-option>
          <b-form-select-option value="2">Tijuana</b-form-select-option>
          <b-form-select-option value="3">Tuxpan</b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group class="custom-f-group-s1">
        <b-form-select required class="form-select" v-bind:class="{ 'text-muted' : searchForm.destino == null }" v-model="searchForm.destino">
          <b-form-select-option :value="null">Destino</b-form-select-option>
          <b-form-select-option value="1">Guadalajara</b-form-select-option>
          <b-form-select-option value="2">Tijuana</b-form-select-option>
          <b-form-select-option value="3">Tuxpan</b-form-select-option>
        </b-form-select>
      </b-form-group>

      <h4 class="mt-3 mt-sm-4 mb-1 mb-sm-2 title-1">PASAJEROS</h4>

      <!-- Adulto -->
      <div class="box-passengers">
        <div class="col col-text">
          <h5>Adulto</h5>
          <p>
            Mayores de 15 años
          </p>
        </div>

        <div class="col col-quantity">
          <div class="b-quantity">
            <i class="far fa-minus-circle btn-action" @click="(searchForm.adultos >= 1) ? searchForm.adultos-- : 0"></i>
            <span class="quantity">{{ searchForm.adultos }}</span>
            <i class="far fa-plus-circle btn-action" @click="searchForm.adultos++"></i>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- Menor -->
      <div class="box-passengers">
        <div class="col col-text">
          <h5>Menor</h5>
          <p>
            Niños de 3 a 11 años acompañados de papas
          </p>
        </div>

        <div class="col col-quantity">
          <div class="b-quantity">
            <i class="far fa-minus-circle btn-action" @click="(searchForm.menores >= 1) ? searchForm.menores-- : 0"></i>
            <span class="quantity">{{ searchForm.menores }}</span>
            <i class="far fa-plus-circle btn-action" @click="searchForm.menores++"></i>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- INSEN -->
      <div class="box-passengers">
        <div class="col col-text">
          <h5>INSEN</h5>
          <p>
            Credencial requerida
          </p>
        </div>

        <div class="col col-quantity">
          <div class="b-quantity">
            <i class="far fa-minus-circle btn-action" @click="(searchForm.insen >= 1) ? searchForm.insen-- : 0"></i>
            <span class="quantity">{{ searchForm.insen }}</span>
            <i class="far fa-plus-circle btn-action" @click="searchForm.insen++"></i>
          </div>
        </div>
      </div>
      <!--  -->
    </div>

    <div class="box-button">
      <b-button type="submit" class="btn-search">BUSCAR</b-button>
    </div>
  </b-form>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        type: 1,
        ida: null,
        regreso: null,
        origen: null,
        destino: null,
        adultos: 0,
        menores: 0,
        insen: 0,
      },

      // == Variables para datepicker y timepicker ==
      minDate: null,
      dateFormOpts: { year: 'numeric', month: 'numeric', day: 'numeric' },
      datepickerOpts: {
        labelPrevYear: 'Año anterior',
        labelPrevMonth: 'Mes anterior',
        labelCurrentMonth: 'Mes actual',
        labelNextMonth: 'Mes siguiente',
        labelNextYear: 'Año siguiente',
        labelToday: 'Hoy',
        labelSelected: 'Fecha Seleccionada',
        labelNoDateSelected: 'No seleccionado',
        labelCalendar: 'Calendario',
        labelHelp: 'Use las teclas de movimiento para navegar'
      },
      // == ==
    }
  },

  methods: {
    selectType(opt) {
      this.searchForm.type = opt;
    },

    onSubmitTrip() {
      event.preventDefault();

      if( this.$root.modalTrips ) {
        this.$root.modalTrips = false;
      }

      this.$router.push({ path: "/viajes" });
    },
  },

  beforeMount(){
    const now = new Date();
    this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  },
}
</script>
